import React from 'react';
import { Edit } from 'react-admin';
import { parse } from 'query-string';
import ExperienceForm from './ExperienceForm';
import BackButton from 'components/BackButton';

const FormationEdit = (props: any) => {
  const { consultantskillset } = parse(props.location.search);
  const redirect = `/consultantskillsets/${consultantskillset}/2`;

  return (
    <Edit {...props} actions={<BackButton goTo={redirect} />} undoable={false}>
      <ExperienceForm redirect={redirect} location={props.location} />
    </Edit>
  );
};

export default FormationEdit;
